import { useState, type FormEvent } from 'react'
import { useAuth } from '../auth/AuthContext.tsx'
import { ApiError } from '../api.ts'

export function LoginPage() {
  const { login } = useAuth()
  const [code, setCode] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function onSubmit(e: FormEvent) {
    e.preventDefault()
    setError(null)
    setBusy(true)
    try {
      await login(code, password)
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Coś poszło nie tak')
      setBusy(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100 p-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-6">
          <h1 className="text-2xl font-bold text-brand-700">Centrum Sadownicze Warka</h1>
          <p className="text-slate-500 text-sm mt-1">System CRM</p>
        </div>

        <form onSubmit={onSubmit} className="bg-white rounded-lg shadow-sm border border-slate-200 p-6 space-y-4">
          <div>
            <label htmlFor="code" className="block text-sm font-medium text-slate-700 mb-1">
              Kod użytkownika
            </label>
            <input
              id="code"
              type="text"
              autoFocus
              autoComplete="username"
              value={code}
              onChange={(e) => setCode(e.target.value.toUpperCase())}
              placeholder="np. MP"
              maxLength={3}
              className="w-full px-3 py-2 border border-slate-300 rounded-md uppercase tracking-widest font-mono focus:border-brand-600"
            />
          </div>

          <div>
            <label htmlFor="password" className="block text-sm font-medium text-slate-700 mb-1">
              Hasło
            </label>
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-3 py-2 border border-slate-300 rounded-md focus:border-brand-600"
            />
          </div>

          {error && (
            <div role="alert" className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-md px-3 py-2">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={busy || !code || !password}
            className="w-full bg-brand-600 text-white font-medium py-2 rounded-md hover:bg-brand-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            {busy ? 'Logowanie…' : 'Zaloguj'}
          </button>
        </form>

        <p className="text-center text-xs text-slate-400 mt-4">
          Hasła do kont demo wypisały się w oknie, w którym uruchomiono program.
        </p>
      </div>
    </div>
  )
}
